import script from "./Tooltip.vue?vue&type=script&setup=true&lang=ts"
export * from "./Tooltip.vue?vue&type=script&setup=true&lang=ts"

import "./Tooltip.vue?vue&type=style&index=0&id=da9a52a0&lang=sass&scoped=true"

import exportComponent from "/home/ec2-user/environment/test_front/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-da9a52a0"]])

export default __exports__